import { css } from '@emotion/react'
import {
  CornerRadius,
  Spacing,
  ThemedColors,
  Typography,
  cssVar,
  gemVar,
} from '@opallabs/gem'
import type { UseAddToPlanStateValue } from './types'

export const heightValues = {
  baseContent: 45,
  singleSelect: 61,
  singleLineMessage: 53,
  twoLineMessage: 74,
  margin: Spacing.M,
}

export const getLoaderHeight = ({
  momentCount,
  validation,
}: {
  momentCount: number
  validation: UseAddToPlanStateValue['validation']
}) => {
  const hasValidMoments = validation.momentStamps.length !== momentCount
  const hasStampMoments = Boolean(validation.momentStamps.length)

  if (hasStampMoments) {
    return hasValidMoments
      ? heightValues.baseContent +
          heightValues.twoLineMessage +
          heightValues.margin
      : heightValues.twoLineMessage - heightValues.margin
  }
  return heightValues.baseContent
}

export const classes = {
  descriptionClass: 'add-to-plan-description',
  messageClass: 'add-to-plan-message',
}

export const modalBody = css({
  display: 'flex',
  flexFlow: 'column',
  gap: Spacing.M,
  overflow: 'inherit',
})

export const modalContent = css({
  inlineSize: 400,
  overflow: 'visible',

  [`p:last-of-type.${classes.descriptionClass}`]: {
    marginBlockStart: Spacing.M,
    marginInline: Spacing.M * 2,
  },

  [`.${classes.messageClass} + .lapidary-cascading-single-select, .${classes.messageClass} + .${classes.messageClass}`]:
    {
      marginBlockStart: Spacing.M,
    },
})

export const buttonLink = css({
  textDecoration: 'none',
  marginBlockStart: Spacing.XS,
})

export const messageContainer = css({
  ...Typography.T500,
  alignItems: 'center',
  backgroundColor: gemVar(ThemedColors.Surface2),
  borderRadius: CornerRadius.Small,
  color: gemVar(ThemedColors.TextSecondary),
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing.XS,
  justifyContent: 'center',
  padding: Spacing.M,
  textAlign: 'center',
})

export const inlineMessageContainer = css({
  ...Typography.T500,
  backgroundColor: gemVar(ThemedColors.Surface2),
  borderRadius: CornerRadius.Small,
  color: gemVar(ThemedColors.TextSecondary),
  padding: Spacing.M,

  span: {
    color: cssVar(ThemedColors.TextLinks),
    '&:hover': {
      cursor: 'pointer',
    },
  },
})

export const loader = css({
  display: 'flex',
  alignItems: 'center',
  blockSize: 63, // height of single select + label
  gap: Spacing.XS,
  marginBlockStart: Spacing.M,
})

export const footer = css({
  alignItems: 'center',
  columnGap: 0,
  justifyContent: 'space-between',
})

export const footerButtons = css({
  display: 'flex',
  columnGap: 12,
})

export const selectionText = css({
  color: cssVar(ThemedColors.TextSecondary),
  marginBlockEnd: 0,
})
